import { NgModule, LOCALE_ID, inject, provideAppInitializer } from '@angular/core';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import {
  AbstractSecurityStorage,
  AuthModule,
  DefaultLocalStorageService,
  StsConfigLoader,
} from 'angular-auth-oidc-client';
import { provideDatadogErrorHandler, provideDatadogRouter } from '@datadog/browser-rum-angular';
import { environment } from 'src/environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SsoModule } from './sso/sso.module';
import { SharedModule } from './shared/shared.module';
import { LoggedModule } from './logged-module/logged.module';
import { FormsModule } from '@angular/forms';
import { GeneratedApiModule } from '../generated-sources/openapi/generated-api.module';
import { AppConfigService } from './services/app-config.service';
import { ComponentModule } from './components/component.module';
import { authConfigFactory } from './auth/auth-config.factory';
import { authInterceptor } from './auth/interceptors/auth.interceptor';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    LoggedModule,
    FormsModule,
    AppRoutingModule,
    SsoModule,
    AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: authConfigFactory,
        deps: [AppConfigService],
      },
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
    GeneratedApiModule,
    ComponentModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 5000 } },
    { provide: AbstractSecurityStorage, useClass: DefaultLocalStorageService },
    provideAppInitializer(() => {
      inject(AppConfigService).loadConfig();
    }),
    provideHttpClient(withInterceptors([authInterceptor]), withInterceptorsFromDi()),
    // Datadog Angular integration. The SDK init runs in main.ts; these providers wire the
    // ErrorHandler (preserves super.handleError → console) and Router instrumentation, and
    // are no-ops while the SDK is not initialized.
    provideDatadogErrorHandler(),
    provideDatadogRouter(),
  ],
})
export class AppModule {}
